export default __webpack_public_path__ + "static/SRC 3212 - Product Specifications & Technical Data-acffa18cff101bac0071235e7363f32a.pdf";